import { render } from "./tw-icon.vue?vue&type=template&id=4d8cc066"
import script from "./tw-icon.vue?vue&type=script&lang=js"
export * from "./tw-icon.vue?vue&type=script&lang=js"
script.render = render

export default script